import { render } from "./MadeGVA.vue?vue&type=template&id=77870595&scoped=true"
import script from "./MadeGVA.vue?vue&type=script&lang=js"
export * from "./MadeGVA.vue?vue&type=script&lang=js"

import "./MadeGVA.vue?vue&type=style&index=0&id=77870595&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77870595"]])

export default __exports__